import moment from 'moment';

import { RegionDto, RegionsClient } from '@medone/medonehp-api-client';

import { handleError } from '../../../../shared/common/HandleErrors';
import { Axios } from '../../../../shared/common/http';
import { AppDispatch, AppThunk, RootState } from '../../../../shared/store';
import { setRegion, setRegions } from './slice';

const now = moment();

export function fetchRegions(): AppThunk {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        const { regions } = getState().admin;

        if (regions != null && regions.length > 0) {
            // Prevent double calls
            return;
        }

        const client = new RegionsClient(null, Axios);

        try {
            const response = await client.getAll();

            if (response.result.succeeded) {
                dispatch(setRegions(response.result.entity));
            } else {
                handleError(response);
            }
        } catch (error) {
            handleError(error);
        }
    };
}

export function fetchRegion(regionId: number): AppThunk {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        const client = new RegionsClient(null, Axios);

        try {
            const response = await client.getById(regionId);

            if (response.result.succeeded) {
                dispatch(setRegion(response.result.entity));
            } else {
                handleError(response);
            }
        } catch (error) {
            handleError(error);
        }
    };
}

export function updateRegion(region: RegionDto): AppThunk<Promise<boolean>> {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        const client = new RegionsClient(null, Axios);

        try {
            const response = await client.post(region);

            if (response.result.succeeded) {
                dispatch(setRegion(response.result.entity));
            } else {
                handleError(response);
            }

            return response.result.succeeded;
        } catch (error) {
            handleError(error);
        }

        return false;
    };
}

export const selectRegions = (state: RootState) => state.admin.regions;
export const selectRegion = (state: RootState) => state.admin.currentRegion;
export const selectActiveRegions = (state: RootState) =>
    (state.admin.regions ?? []).filter((x) => x.isActive && x.activeStartDate <= now && (!x.activeEndDate || x.activeEndDate > now));
